import { useRef as f, useState as l, useEffect as h } from "react";
function g(r, m = !1) {
  const e = f(r * 1e3), c = f(r * 1e3), [d, s] = l(r), [t, p] = l(m);
  return h(() => {
    if (!t || e.current <= 0) return () => {
    };
    const w = e.current;
    let o, n;
    const i = (u) => {
      o === void 0 && (o = u);
      const A = u - o;
      if (e.current = w - A, e.current <= 0)
        s(0), cancelAnimationFrame(n);
      else {
        const a = Math.floor(e.current / 1e3), F = a !== Math.floor(c.current / 1e3);
        c.current = e.current, F && s(a), t && (n = window.requestAnimationFrame(i));
      }
    };
    return n = window.requestAnimationFrame(i), () => {
      cancelAnimationFrame(n);
    };
  }, [t]), [d, t, p];
}
export {
  g as useCountDown
};
//# sourceMappingURL=useCountDown.js.map
